import { dictionary } from "../../../utils/dictionary";
import { useAuth } from "../../../context/AuthContext";

interface ImportProductFromLinkHeaderProps {
  name?: string;
}

function ImportProductFromLinkHeader({ name = 'product' }: ImportProductFromLinkHeaderProps) {
  const { language } = useAuth();
  
  return (
    <div className="flex justify-between items-center mb-4">
      <h4 className="text-lg font-medium">{dictionary[`import-${name}-from-link`][language]}</h4>
      <div className="flex items-center space-x-2">
        <div className="bg-gray-100 p-1 rounded-md">
          <img
            src="https://i.ibb.co/NdnhLqqH/ali.png"
            alt="AliExpress"
            className="h-5 w-5"
          />
        </div>
        <div className="bg-gray-100 p-1 rounded-md">
          <img
            src="https://www.svgrepo.com/show/303503/shopify-logo.svg"
            alt="Shopify"
            className="h-5 w-5"
          />
        </div>
        <div className="bg-gray-100 p-1 rounded-md">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg"
            alt="Amazon"
            className="h-5 w-5"
          />
        </div>
        <div className="bg-gray-100 p-1 rounded-md">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIXvb1uc1DLyblcMGgEtWTLtXEYzuBfvZ6UQ&s"
            alt="Etsy"
            className="h-5 w-5"
          />
        </div>
        <div className="bg-gray-100 p-1 rounded-md">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQKVO4c8b5IsJUTtIjl5ShRPxonqTUzDvD3vw&s"
            alt="eBay"
            className="h-5 w-5"
          />
        </div>
      </div>
    </div>
  );
}

export default ImportProductFromLinkHeader;
